webpackJsonp([1],{

/***/ 113:
/*!*******************************************!*\
  !*** ./src/components/InvoiceDetails.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_buildhome_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetails_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/buildhome/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InvoiceDetails.vue */ 31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef4ae40c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetails_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ef4ae40c","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InvoiceDetails.vue */ 120);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ef4ae40c","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./InvoiceDetails.vue */ 114)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef4ae40c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_buildhome_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef4ae40c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 114:
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ef4ae40c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/InvoiceDetails.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/*!**************************************!*\
  !*** ./src/components/Braintree.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_buildhome_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Braintree_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/buildhome/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Braintree.vue */ 32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2ab9a52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Braintree_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f2ab9a52","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Braintree.vue */ 119);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f2ab9a52","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Braintree.vue */ 117)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2ab9a52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_buildhome_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Braintree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2ab9a52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Braintree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 117:
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2ab9a52","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Braintree.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2ab9a52","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Braintree.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticStyle:{"height":"40vh","display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('OrbitSpinner',{attrs:{"size":55,"color":"#431266"}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('center',[_vm._v(_vm._s(_vm.loadingMessage))])],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticStyle:{"width":"100%","margin":"auto","padding-top":"1em"}},[_c('div',{attrs:{"id":"dropin-container"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.savePaymentInfo),expression:"savePaymentInfo"}],staticStyle:{"margin-right":"10px","margin-top":"10px"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.savePaymentInfo)?_vm._i(_vm.savePaymentInfo,null)>-1:(_vm.savePaymentInfo)},on:{"change":function($event){var $$a=_vm.savePaymentInfo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.savePaymentInfo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.savePaymentInfo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.savePaymentInfo=$$c}}}}),_vm._v("\n\t\tSave this payment info with our payment provider (secure) for future payments.\n\t\t"),_c('br'),_vm._v(" "),(_vm.savePaymentInfo)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowCharge),expression:"allowCharge"}],staticStyle:{"margin-right":"10px","margin-top":"10px"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.allowCharge)?_vm._i(_vm.allowCharge,null)>-1:(_vm.allowCharge)},on:{"change":function($event){var $$a=_vm.allowCharge,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allowCharge=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allowCharge=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allowCharge=$$c}}}}),_vm._v("\n\t\t\tAllow us to charge this credit card automatically for future invoices.\n\t\t")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","width":"100%","justify-content":"center","margin-top":"30px"}},[(_vm.formLoaded)?_c('button',{staticStyle:{"width":"70%"},on:{"click":_vm.submitForm}},[_vm._v("Pay Now")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 120:
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef4ae40c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvoiceDetails.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoice"},[_c('h4',{staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.details.name)+", thank you for your order!")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('h4',[_vm._v("Invoice "+_vm._s(_vm.invoiceNumber))]),_vm._v(" "),_c('p'),_vm._v(" "),_c('h4',[_vm._v("Amount Due HKD: $"+_vm._s(_vm.details.amount_due.toFixed(2)))])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"-5px"}}),_vm._v(" "),(_vm.showdetails)?_c('table',{staticStyle:{"width":"100%"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.details.lines),function(line,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"width":"80%"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(line.Name)),_c('br'),_vm._v(" "),(line.Comment)?_c('div',[_c('br'),_c('em',[_vm._v(_vm._s(line.Comment))])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(_vm._s(line.Quantity.toFixed(2))+" x "+_vm._s(line.Price)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticStyle:{"float":"right"}},[_vm._v("$"+_vm._s(line.Total.toFixed(2)))])])}),_vm._v(" "),_vm._l((_vm.details.charges),function(charge,index){return _c('tr',{key:index+200},[_c('td',{staticStyle:{"width":"80%"}},[_vm._v(_vm._s(charge.Description)),_c('br'),_c('br'),_vm._v(_vm._s(charge.Quantity.toFixed(2))+" x "+_vm._s(charge.Price))]),_vm._v(" "),_c('td',{staticStyle:{"float":"right"}},[_vm._v("$"+_vm._s(charge.Total.toFixed(2)))])])})],2):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"cursor":"pointer","margin-bottom":"5px","font-style":"italic"},on:{"click":_vm.showInvoiceDetails}},[_vm._v(_vm._s(!_vm.showdetails ? "Show" : "Hide")+" invoice details")])]),_vm._v(" "),_c('div',{staticClass:"payment-method"},[_c('transition',[(_vm.braintree)?_c('Braintree',{attrs:{"endpoint":_vm.endpoint,"amount":_vm.details.amount_due.toFixed(2),"invoiceNumber":_vm.invoiceNumber},on:{"nonceLoaded":_vm.nonceLoaded}}):_vm._e()],1),_vm._v(" "),_c('h5',[_vm._v("Or, pay with:")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","margin":"auto","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticClass:"button",staticStyle:{"width":"100%","margin":"auto"},on:{"click":function($event){return _vm.$emit('methodChosen', 'QFPay')}}},[_vm._v("AlipayHK / Alipay / Wechat Pay / FPS")]),_vm._v(" "),_c('div',{staticClass:"paypal-button",attrs:{"id":"paypal-button-container"}})])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',{staticStyle:{"float":"right"}},[_vm._v("Amount")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 121:
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b1a5f2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticStyle:{"margin-top":"2em"},attrs:{"src":"/logo.png","width":"200px"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticStyle:{"height":"40vh","display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('OrbitSpinner',{attrs:{"size":55,"color":"#431266"}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('center',[_vm._v("Loading..Please wait..")])],1)]):_vm._e(),_vm._v(" "),(_vm.show)?_c('invoice-details',{attrs:{"details":_vm.details,"name":_vm.name,"endpoint":_vm.endpoint,"invoiceNumber":_vm.invoiceNumber},on:{"methodChosen":_vm.methodChosen,"paymentDone":_vm.paymentDone,"nonceLoaded":_vm.brainTreeSubmit}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('p',{staticStyle:{"margin-top":"10%"}},[_vm._v("Error: invalid Link. Please contact us.")]):_vm._e(),_vm._v(" "),(_vm.paymentfailed)?_c('div',{staticStyle:{"margin-top":"10%"}},[_c('p',[_vm._v("Your payment has failed. Please try again.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.retryURL}},[(_vm.showbutton)?_c('button',{staticClass:"button",staticStyle:{"margin-top":"3em"}},[_vm._v("Try Again")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.thankyou)?_c('div',{staticStyle:{"margin-top":"5%","width":"100%"}},[_c('p',[_vm._v("We have received your payment.")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.invoiceNumber ? "Invoice Number:" + _vm.invoiceNumber : "")+" "+_vm._s(_vm.payment_ref ? "Payment Reference: " + _vm.payment_ref : ""))]),_vm._v(" "),_c('p',[_vm._v("You may now close this window.")])]):_vm._e(),_vm._v(" "),(_vm.paying)?_c('div',{staticStyle:{"margin-top":"5%","width":"100%"}},[_vm._v("\n\t\tWe are processing this invoice.  We may contact you if your payment fails.\n\t")]):_vm._e(),_vm._v(" "),(_vm.paid)?_c('div',{staticStyle:{"margin-top":"5%","width":"100%"}},[_c('p',[_vm._v("This invoice has been paid. Thank you.")])]):_vm._e(),_vm._v(" "),(!_vm.thankyou && !_vm.paid)?_c('div',{staticClass:"disclaimer"},[_c('em',[_vm._v("All payment are performed under an encrypted network and a secure method of data transmission provided by our payment partners. When\n\t\t\tprocessing payment, your details are automatically redirected toward payment provider's servers which handle the all operation while meeting\n\t\t\tthe latest security requirements.")])]):_vm._e(),_vm._v(" "),_c('small',{staticStyle:{"margin":"5em"}},[_c('center',[_vm._v("Build version 123979")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 31:
/*!**************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/buildhome/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InvoiceDetails.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paypal_paypal_js__ = __webpack_require__(/*! @paypal/paypal-js */ 115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Braintree_vue__ = __webpack_require__(/*! ./Braintree.vue */ 116);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "InvoiceDetails",
	props: ["details", "endpoint", "name", "invoiceNumber"],
	components: { Braintree: __WEBPACK_IMPORTED_MODULE_1__Braintree_vue__["a" /* default */] },
	data: function data() {
		return {
			braintree: true,
			showdetails: false
		};
	},
	mounted: function mounted() {
		var urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('pp34') == "true") this.mountpaypalbutton();
	},

	methods: {
		mountpaypalbutton: function mountpaypalbutton() {
			var _this = this;

			var id = this.details.id;
			var invoice_amount = this.details.invoice_total;
			Object(__WEBPACK_IMPORTED_MODULE_0__paypal_paypal_js__["a" /* loadScript */])({ "client-id": this.ppclientid, currency: "HKD" }) // production
			.then(function (paypal) {
				var paypalButtonsComponent = paypal.Buttons({
					fundingSource: paypal.FUNDING.PAYPAL,
					style: {
						color: "white",
						shape: "pill",
						layout: "horizontal",
						height: 38
					},

					// set up the transaction
					createOrder: function createOrder(data, actions) {
						// pass in any options from the v2 orders create call:
						// https://developer.paypal.com/api/orders/v2/#orders-create-request-body
						var createOrderPayload = {
							purchase_units: [{
								reference_id: _this.details.id,
								amount: {
									value: _this.details.amount_due
								}
							}]
						};

						return actions.order.create(createOrderPayload);
					},

					// finalize the transaction
					onApprove: function onApprove(data, actions) {
						var captureOrderHandler = function captureOrderHandler(details) {
							_this.$emit("paymentDone", "Paypal", details.id);
							var payerName = details.payer.name.given_name;
						};

						return actions.order.capture().then(captureOrderHandler);
					},

					// handle unrecoverable errors
					onError: function onError(err) {
						alert("An error has occured with PayPal. Please try again.");
						console.error("An error prevented the buyer from checking out with PayPal");
					}
				});

				paypalButtonsComponent.render("#paypal-button-container").catch(function (err) {
					console.error("PayPal Buttons failed to render");
				});
			}).catch(function (err) {
				console.error("failed to load the PayPal JS SDK script", err);
			});
		},
		showBrainTree: function showBrainTree() {
			this.braintree = true;
		},
		nonceLoaded: function nonceLoaded(payload, save, allow) {
			this.$emit("nonceLoaded", payload, save, allow);
		},
		showInvoiceDetails: function showInvoiceDetails() {
			this.showdetails = !this.showdetails;
		}
	},
	computed: {
		ppclientid: function ppclientid() {
			if (window.location.href.includes('localhost')) {
				return "AfwhSt6svwhlwboNA-bOkSF5_BXgJpRZKiFvQpe5Q92RGsts9ri1ECnDouTdmn1PQC8BnJOY2ml2e-bc";
			} else {
				return 'AYYi1JgQ3Mw5u3hzlKvWmqmcUM-81ayiquSesmcJrYUEoPEo2RCys45auyBpgt35WqeHIHToKDaNWmNl';
			}
		}
	}
});

/***/ }),

/***/ 32:
/*!*********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/buildhome/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Braintree.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(/*! epic-spinners */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_braintree_web_drop_in__ = __webpack_require__(/*! braintree-web-drop-in */ 118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_braintree_web_drop_in___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_braintree_web_drop_in__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Braintree",
	props: ["endpoint", "amount", 'invoiceNumber'],
	components: { OrbitSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* OrbitSpinner */] },
	data: function data() {
		return {
			loading: true,
			instance: null,
			formLoaded: false,
			showButton: true,
			loadingMessage: "Loading..Please Wait..",
			savePaymentInfo: true,
			allowCharge: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		axios.get(this.endpoint + "create_bt_token" + "?invoiceNumber=" + this.invoiceNumber).then(function (response) {
			var token = response.data.token;

			__WEBPACK_IMPORTED_MODULE_1_braintree_web_drop_in___default.a.create({
				authorization: token,
				container: "#dropin-container",
				card: {
					cardholderName: {
						required: true
					}
				},
				applePay: {
					displayName: "Eatology Limited",
					paymentRequest: {
						total: {
							label: "Eatology Limited",
							amount: _this.amount
						},
						// We recommend collecting billing address information, at minimum
						// billing postal code, and passing that billing postal code with all
						// Apple Pay transactions as a best practice.
						requiredBillingContactFields: ["postalAddress"]
					}
				},
				googlePay: {
					googlePayVersion: 2,
					merchantId: "BCR2DN6TVPCM72IS",
					transactionInfo: {
						totalPriceStatus: "FINAL",
						totalPrice: _this.amount,
						currencyCode: "HKD"
					},
					allowedPaymentMethods: [{
						type: "CARD",
						parameters: {
							// We recommend collecting and passing billing address information with all Google Pay transactions as a best practice.
							billingAddressRequired: true,
							billingAddressParameters: {
								format: "FULL"
							}
						}
					}]
				}
			}).then(function (instance) {
				_this.loading = false;
				_this.formLoaded = true;
				_this.instance = instance;
				instance.on("paymentMethodRequestable", function (event) {
					if (event.type == "ApplePayCard") {
						this.submitForm();
					}
				}.bind(_this));
			}).catch(function (error) {
				console.log(error);
				alert("2 An error has occured, please try again");
			});
		}).catch(function (error) {
			alert("1 An error has occured, please try again.");
		});
	},

	methods: {
		submitForm: function submitForm() {
			var _this2 = this;

			this.formLoaded = false;
			this.instance.requestPaymentMethod().then(function (payload) {
				_this2.$emit("nonceLoaded", payload, _this2.savePaymentInfo, _this2.allowCharge);
			}).catch(function (error) {
				_this2.formLoaded = true;
			});
		}
	}
});

/***/ }),

/***/ 42:
/*!***********************************************!*\
  !*** multi ./src/polyfills.js ./src/index.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! /opt/buildhome/repo/src/polyfills.js */43);
module.exports = __webpack_require__(/*! /opt/buildhome/repo/src/index.js */47);


/***/ }),

/***/ 43:
/*!**************************!*\
  !*** ./src/polyfills.js ***!
  \**************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

if (!window.Promise) {
  window.Promise = __webpack_require__(/*! promise-polyfill */ 44);
}

Object.assign = __webpack_require__(/*! object-assign */ 46);

/***/ }),

/***/ 47:
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App_vue__ = __webpack_require__(/*! ./components/App.vue */ 49);



window.axios = __webpack_require__(/*! axios */ 122);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__components_App_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 49:
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_buildhome_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/buildhome/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b1a5f2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-26b1a5f2","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 121);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-26b1a5f2","scoped":false,"hasInlineConfig":true}!normalize.css/normalize.css */ 50)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-26b1a5f2","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./App.vue */ 51)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-26b1a5f2","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=2!./App.vue */ 52)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26b1a5f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_buildhome_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b1a5f2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 51:
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26b1a5f2","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/App.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26b1a5f2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/components/App.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/buildhome/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(/*! epic-spinners */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InvoiceDetails_vue__ = __webpack_require__(/*! ./InvoiceDetails.vue */ 113);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "app",
	components: {
		InvoiceDetails: __WEBPACK_IMPORTED_MODULE_1__InvoiceDetails_vue__["a" /* default */],
		OrbitSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* OrbitSpinner */]
	},
	data: function data() {
		return {
			loading: true,
			thankyou: false,
			encryptedId: null,
			invoiceNumber: null,
			payment_ref: null,
			error: false,
			details: {},
			show: false,
			paid: false,
			paying: false,
			paymentfailed: false,
			errormsg: "",
			name: "",
			showbutton: true,
			showref: false,
			version: "v1"

		};
	},
	mounted: function mounted() {
		var _this = this;

		var urlParams = new URLSearchParams(window.location.search);

		var c = urlParams.get('c');
		this.encryptedId = c;
		var page = urlParams.get('page');
		var inv = urlParams.get('inv');
		this.invoiceNumber = inv;
		var ref = urlParams.get('ref');
		this.payment_ref = ref;
		var v = urlParams.get('v');
		this.version = v;
		console.log("version", v);
		if (!c && !page) {
			this.loading = false;
			this.error = true;
			return;
		}

		if (page == "thankyou") {
			this.loading = false;
			this.thankyou = true;
			return;
		}

		if (page == "paymentfailed") {
			this.showbutton = false;
			this.loading = false;
			this.paymentfailed = true;
			if (this.encryptedId) {
				this.showbutton = true;
			}
			return;
		}

		console.log("link", this.endpoint + "get/" + this.encryptedId + "?v=" + this.version);
		axios.get(this.endpoint + "get/" + this.encryptedId + "?v=" + this.version).then(function (response) {
			if ("error" in response.data) {
				_this.error = true;
				_this.loading = false;
			}
			_this.details = response.data.invoice;
			_this.invoiceNumber = response.data.invoice.invoice_number;
			_this.name = response.data.name;
			_this.loading = false;
			if (response.data.status == "paid") {
				_this.paid = true;
			} else if (response.data.status == "paying") {
				_this.paying = true;
			} else {
				_this.show = true;
			}
		}).catch(function (error) {
			console.log(error.response);
			_this.loading = false;
		});
	},

	methods: {
		methodChosen: function methodChosen(x) {
			if (x == "QFPay") {
				this.loading = true;
				this.show = false;
				axios.get(this.endpoint + "create_qfpay_checkout/" + this.encryptedId + "?v=" + this.version).then(function (_ref) {
					var data = _ref.data;

					console.log(data);
					window.location.href = data.url;
				}).catch(function (error) {
					alert("error occured");
				});
				return;
			}
			alert(x);
			return;
		},
		paymentDone: function paymentDone(method, reference) {
			var _this2 = this;

			this.loading = true;
			this.show = false;
			axios.get(this.endpoint + "preprocess_paypal?c=" + this.encryptedId + "&ref=" + reference + "&v=" + this.version).then(function (response) {
				_this2.payment_ref = reference;
				_this2.show = false;
				_this2.thankyou = true;
				_this2.loading = false;
			}).catch(function (error) {
				console.log(error.response);
			});
		},
		brainTreeSubmit: function brainTreeSubmit(payload, save, allow) {
			var _this3 = this;

			this.loading = true;
			this.show = false;
			axios.post(this.endpoint + "create_bt_transaction", {
				payload: payload,
				sub_id: this.encryptedId,
				saveCard: save,
				allowCharge: allow,
				v: this.version
			}).then(function (response) {
				if (response.data.status == "OK") {
					_this3.loading = false;
					_this3.payment_ref = response.data.ref;
					_this3.show = false;
					_this3.thankyou = true;
					_this3.showref = true;
				} else {
					_this3.loading = false;
					_this3.show = false;
					_this3.paymentfailed = true;
					_this3.retry = _this3.params;
					_this3.errormsg = response.data.message;
				}
			});
		}
	},
	computed: {
		endpoint: function endpoint() {
			if (window.location.href.includes('localhost')) {
				return "http://localhost:3000/payments/";
			} else {
				return 'https://healthyfood.app/payments/';
			}
		},
		retryURL: function retryURL() {
			return "https://payments.eatologyasia.com/?c=" + this.encryptedId + "&v=" + this.version;
		}
	}
});

/***/ })

},[42]);


// WEBPACK FOOTER //
// client.7bdd473e.js